import * as React from "react";
import styled from "styled-components";
import { Alert, Col, Row } from "components/bootstrap";
import ProviderName from "ai-management/components/ProviderName";
import useConfiguredModelProviders from "ai-management/model-providers/hooks/useConfiguredModelProviders";
const StyledAlert = styled(Alert)`
  margin-top: 0;
  margin-bottom: 0;
`;
const DisabledDefaultProviderAlert = () => {
  const { data: providers } = useConfiguredModelProviders();
  const disabledDefault = providers.find(({ is_default, enabled }) => is_default && !enabled);
  if (!disabledDefault) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning", title: "Default model provider disabled" }, "The default model provider ", /* @__PURE__ */ React.createElement(ProviderName, { providerId: disabledDefault.provider }), " is disabled by the server configuration. Features without a usable provider of their own cannot run until you make another model provider the default.")));
};
export default DisabledDefaultProviderAlert;
